export function buildTrendRegressionLine(points) {
  const pts = (Array.isArray(points) ? points : [])
    .map((point) => ({
      x: Number(point?.x),
      y: Number(point?.y),
    }))
    .filter(
      (point) => Number.isFinite(point.x) && Number.isFinite(point.y),
    );

  if (pts.length < 2) {
    return null;
  }

  let sumX = 0;
  let sumY = 0;
  let sumXX = 0;
  let sumXY = 0;

  for (const point of pts) {
    sumX += point.x;
    sumY += point.y;
    sumXX += point.x * point.x;
    sumXY += point.x * point.y;
  }

  const denom = pts.length * sumXX - sumX * sumX;

  if (Math.abs(denom) < 1e-9) {
    return null;
  }

  const slope = (pts.length * sumXY - sumX * sumY) / denom;
  const intercept = (sumY - slope * sumX) / pts.length;
  const xMin = Math.min(...pts.map((point) => point.x));
  const xMax = Math.max(...pts.map((point) => point.x));
  const yMin = intercept + slope * xMin;
  const yMax = intercept + slope * xMax;

  return {
    points: pts,
    slope,
    intercept,
    xMin,
    xMax,
    yMin,
    yMax,
    delta: yMax - yMin,
  };
}
